<template>
  <div class="rg_detail_page">
    <van-nav-bar title="传话详情" left-arrow @click-left="$router.back()" />

    <div class="rg_card" v-if="item">
      <div class="rg_status">
        <span class="label">状态：</span>
        <span class="status-text" :class="statusClass">{{ getStatusText(item.msgStatus) }}</span>
      </div>

      <div class="rg_row">
        <span class="rg_label">渠道名称：</span>
        <span class="rg_val">{{ item.channelName || '-' }}</span>
      </div>

      <div class="rg_row">
        <span class="rg_label">联系方式：</span>
        <span class="rg_val">{{ item.accountInfo || '-' }}</span>
      </div>

      <!-- 发送内容 -->
      <div class="rg_row content-row">
        <span class="rg_label">发送内容：</span>
        <span class="rg_val">{{ filterHtml(item.content) }}</span>
      </div>

      <div class="rg_row" v-if="item.sendName && item.sendName.trim() !== ''">
        <span class="rg_label">发送者名字：</span>
        <span class="rg_val">{{ item.sendName }}</span>
      </div>

      <div class="rg_row">
        <span class="rg_label">发送时间：</span>
        <span class="rg_val">{{ item.sendTime || '-' }}</span>
      </div>

      <div class="rg_row">
        <span class="rg_label">备注：</span>
        <span class="rg_val">{{ item.userRemark || '无' }}</span>
      </div>

      <div class="rg_row fail-row" v-if="item.msgStatus === 2">
        <span class="rg_label">失败原因：</span>
        <span class="rg_val red">{{ item.failReason || '未知原因' }}</span>
      </div>

      <div class="rg_row" v-if="item.msgStatus === 0">
        <span class="rg_label">回复条数：</span>
        <span class="rg_val">{{ item.replyCount || 0 }}</span>
      </div>
    </div>

    <div class="rg_card" v-if="imgList.length > 0">
      <div class="rg_section_title">回复图片</div>
      <div class="rg_img_list">
        <img v-for="(img, idx) in imgList" :key="idx" :src="img" class="rg_img" @click="previewImg(img)" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { NavBar as VanNavBar, ImagePreview } from 'vant'

const router = useRouter()
const item = ref({})

onMounted(() => {
  const data = localStorage.getItem('currentMsgItem')
  if (data) {
    item.value = JSON.parse(data)
  } else {
    router.back()
  }
})

const filterHtml = (str) => {
  if (!str) return ''
  return str.replace(/<[^>]+>/g, '')
}

const getStatusText = (type) => {
  if (type === 0) return '已发送'
  if (type === 1) return '未发送'
  if (type === 2) return '发送失败'
  if (type === 3) return '已取消'
  if (type === 4) return '审核中'
  if (type === 5) return '审核不过'
  return '未知状态'
}

const statusClass = computed(() => {
  if (!item.value) return ''
  const s = item.value.msgStatus
  if (s === 0) return 'succeed'
  if (s === 1) return 'waiting'
  if (s === 2) return 'failed'
  if (s === 3) return 'cancel'
  if (s === 4 || s === 5) return 'verify'
  return ''
})

const imgList = computed(() => {
  if (!item.value || !item.value.replayImgs) return []
  return item.value.replayImgs.split(',').filter(i => i.trim())
})

const previewImg = (url) => {
  ImagePreview({
    images: imgList.value,
    startPosition: imgList.value.indexOf(url)
  })
}
</script>

<style scoped>
.rg_detail_page {
  background: #f7f7f7;
  min-height: 100vh;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.rg_card {
  background: #fff;
  margin: 12px;
  border-radius: 12px;
  padding: 16px;
  box-sizing: border-box;
  max-width: 100%;
}

/* 核心修复：强制换行 + 不超出宽度 */
.rg_row {
  display: flex;
  padding: 10px 0;
  font-size: 15px;
  align-items: flex-start;
  max-width: 100%;
  box-sizing: border-box;
}
.rg_label {
  width: 110px;
  color: #666;
  flex-shrink: 0;
}
.rg_val {
  flex: 1;
  min-width: 0;
  width: 0;
  color: #333;
  line-height: 1.7;
  word-break: break-all;
  white-space: pre-line;
  max-width: 100%;
}

.rg_status {
  font-size: 15px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f2f2;
}
.status-text { font-weight: bold; }
.succeed { color: #00C48C; }
.waiting { color: #FF9500; }
.failed { color: #FF3B30; }
.cancel { color: #999; }
.verify { color: #1379ED; }

.red { color: #ff3b30; }
.fail-row {
  background: #fff5f5;
  padding: 10px;
  border-radius: 8px;
}
.content-row {
  align-items: flex-start;
}

.rg_section_title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
.rg_img_list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.rg_img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
}
</style>